import { render, staticRenderFns } from "./OnlineCultureMedia.vue?vue&type=template&id=97e24f16&"
import script from "./OnlineCultureMedia.vue?vue&type=script&lang=ts&"
export * from "./OnlineCultureMedia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports